<div class="btn btn-dark text-end compareCount clickable"
  [ngClass]="[selectedForCompareCount > 0 ? 'd-lg-inline-block' : 'd-none','count-' + selectedForCompareCount]"
  (click)="showCompared()">
  <span>
    ({{ selectedForCompareCount }}) {{ "COMPARE" | translate }}
  </span>
</div>
